import api from './HttpUtil';

export interface iTematico {
    id: number;
    nombre: string;
    portada: string;
    publicar: number;
    orden: number;
}


export default {
    getAll(){
        return api.get('/tematico/all')
    }
}